import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LANGS } from 'src/constants';

interface LanguageSelectorProps {
  onchange: (value: string) => void;
  value: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  onchange,
  value,
}) => {
  const { t } = useTranslation();

  return (
    <Select
      fullWidth
      value={value}
      //size="small"
      onChange={(e) => {
        onchange(e.target.value as string);
      }}>
      {(Object.values(LANGS) || []).map((value) => (
        <MenuItem key={value} value={value}>
          {t(`langs.${value}`)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LanguageSelector;
